module.exports = __webpack_public_path__ + "static/media/locationBlack.c61a469a.svg";